<template>
  <!-- <div id="seller" class="col">
        <div class="list-group">
            <ValidationObserver v-slot="{ handleSubmit }">
                <form action="" v-if="seller" @submit.prevent="handleSubmit( save )">
                    <div class="row d-flex justify-content-center">
                        <div class="col">
                            <label>Nome:<span style="color:red !important">*</span></label>
                            <ValidationProvider rules="required" v-slot="v">
                                <cc-input type="text" v-model="seller.name"></cc-input>
                                <span class="error">{{ v.errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="col">
                            <label>Email:<span style="color:red !important">*</span></label>
                            <ValidationProvider rules="required" v-slot="v">
                                <cc-input type="text" v-model="seller.email"></cc-input>
                                <span class="error">{{ v.errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="row d-flex justify-content-center">
                        <div class="col">
                            <label>Perfil:<span style="color:red !important">*</span></label>
                            <ValidationProvider rules="required" v-slot="v" name="prof">
                                <cc-select-v2 :tracker="'id'" :text="'name'" v-model="seller.profile" :options="profiles"></cc-select-v2>
                                <span class="error">{{ v.errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="col">
                            <label>Telefone:<span style="color:red !important">*</span></label>
                            <ValidationProvider rules="required" v-slot="v">
                                <cc-input type="text" v-mask="'(##) #.####-####'" v-model="seller.phone"></cc-input>
                                <span class="error">{{ v.errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="row d-flex justify-content-center">
                        <div class="col">
                            <label>Login:<span style="color:red !important">*</span></label>
                            <ValidationProvider rules="required" v-slot="v">
                                <cc-input type="text" v-model="seller.login"></cc-input>
                                <span class="error">{{ v.errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="col">
                            <label>Senha:<span style="color:red !important">*</span></label>
                            <ValidationProvider rules="required" v-slot="v">
                                <cc-input type="password" v-model="seller.password"></cc-input>
                                <span class="error">{{ v.errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>
                    <button ref="send-seller" type="submit" style="display:none;"></button>
                </form>
            </ValidationObserver>
        </div>
    </div> -->
    <div class="add-selller-body">
        <div class="add-seller-title-container">
            {{seller.provider.name }}
            <StandardButtonVue class="add-seller-button" :text="'Voltar'" :action="close" :iconName="'arrow_back'"/>
        </div>
        <div class="add-seller-body">
            <div v-if="generalErrors.length" class="seller-form-errors">
                <span v-for="(error, index) in generalErrors" :key="`general-${index}`" class="error seller-field-error">
                    {{ error }}
                </span>
            </div>
            <div class="add-seller-row">
                <div class="add-seller-input">
                    <StandardInputV2Vue :auto="true" :value="modalSeller.name" :action="setName" title="Nome" type="text" :warning="hasError('usu_nome')"/>
                    <span v-for="(error, index) in fieldErrors('usu_nome')" :key="`name-${index}`" class="error seller-field-error">{{ error }}</span>
                </div>
                <div class="add-seller-input">
                    <StandardInputV2Vue :auto="true" :value="modalSeller.email" :action="setEmail" title="Email" type="text" :warning="hasError('usu_email')"/>
                    <span v-for="(error, index) in fieldErrors('usu_email')" :key="`email-${index}`" class="error seller-field-error">{{ error }}</span>
                </div>
            </div>
            <div class="add-seller-row">
                <div class="add-seller-input">
                    <StandardInputV2Vue :auto="true" title="Perfil" type="select" :value="selectedProfileId" :placeholder="getProfileName(modalSeller.profile)" :list="formatList(profiles)" :action="setProfile" :warning="hasError('profile_id')"/>
                    <span v-for="(error, index) in fieldErrors('profile_id')" :key="`profile-${index}`" class="error seller-field-error">{{ error }}</span>
                </div>
                <div class="add-seller-input">
                    <StandardInputV2Vue :auto="true" :value="modalSeller.phone" :action="setPhone" mask="(##) #.####-####" title="Telefone" type="text" :warning="hasError('usu_telefone')"/>
                    <span v-for="(error, index) in fieldErrors('usu_telefone')" :key="`phone-${index}`" class="error seller-field-error">{{ error }}</span>
                </div>
            </div>
            <div class="add-seller-row">
                <div class="add-seller-input">
                    <StandardInputV2Vue :auto="true" :value="modalSeller.login" :action="setLogin" title="Login" type="text" :warning="hasError('usu_login')"/>
                    <span v-for="(error, index) in fieldErrors('usu_login')" :key="`login-${index}`" class="error seller-field-error">{{ error }}</span>
                </div>
                <div class="add-seller-input">
                    <StandardInputV2Vue :auto="true" :value="modalSeller.password" :action="setPassword" title="Senha" :password="true" type="text" :warning="hasError('raw_password')"/>
                    <span v-for="(error, index) in fieldErrors('raw_password')" :key="`password-${index}`" class="error seller-field-error">{{ error }}</span>
                </div>
            </div>
            <div class="add-selller-buttons">
                <StandardButtonVue class="add-seller-button" :text="'Cancelar'" :action="close" />
                <StandardButtonVue class="add-seller-button" :text="'Salvar'" :action="save" />
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { loaderMixin } from "@/mixins/sweet-loader.mixin";
import SellerService from "@/services/v3/providers/seller.service";
import StandardButtonVue from "../../../components/ui/buttons/StandardButton.vue";
import StandardInputV2Vue from "../../../components/ui/inputs/StandardInputV2.vue";

export default {
  mixins: [loaderMixin],
  components: {
    ValidationProvider,
    ValidationObserver,
    StandardButtonVue,
    StandardInputV2Vue,
  },
  props: ["seller", "profiles", "close"],
  data() {
    return {
      svc: new SellerService(),
      modalSeller: {},
      apiErrors: {},
    };
  },
  computed: {
    selectedProfileId() {
      return this.modalSeller && this.modalSeller.profile
        ? String(this.modalSeller.profile.id)
        : undefined;
    },
    generalErrors() {
      return this.fieldErrors('general');
    },
  },
  created() {
    this.modalSeller = { ...this.seller };
    this.syncSelectedProfile();
  },
  watch: {
    profiles() {
      this.syncSelectedProfile();
    },
    seller: {
      handler(newSeller) {
        this.modalSeller = { ...newSeller };
        this.syncSelectedProfile();
      },
      deep: true,
    },
  },
   methods: {
        syncSelectedProfile() {
            if (!this.modalSeller || !this.modalSeller.profile || !Array.isArray(this.profiles)) {
                return;
            }

            const selectedProfile = this.profiles.find(
                (profile) => String(profile.id) === String(this.modalSeller.profile.id)
            );

            if (selectedProfile) {
                this.modalSeller.profile = selectedProfile;
            }
        },
        getProfileName(profile){ return profile ? profile.name : '' },
        formatList(list) {
            const resp = []
            list.forEach(element => {
                resp.push({
                    text: element.name,
                    value: String(element.id)
                })
            });
            return resp
        },
        setName(value){this.modalSeller.name = value; this.clearFieldError('usu_nome')},
        setEmail(value){this.modalSeller.email = value; this.clearFieldError('usu_email')},
        setPhone(value){this.modalSeller.phone = value; this.clearFieldError('usu_telefone')},
        setLogin(value){this.modalSeller.login = value; this.clearFieldError('usu_login')},
        setPassword(value){this.modalSeller.password = value; this.clearFieldError('raw_password')},
        setProfile(value) {
            this.clearFieldError('profile_id');
            const profile = this.profiles.find(
                (item) => String(item.id) === String(value)
            );
            this.modalSeller.profile = profile || null;
        },
        hasError(field) {
            return this.fieldErrors(field).length > 0;
        },
        fieldErrors(field) {
            const errors = this.apiErrors && this.apiErrors[field];
            if (!errors) return [];
            return Array.isArray(errors) ? errors : [errors];
        },
        clearFieldError(field) {
            if (!this.apiErrors || !this.apiErrors[field]) return;
            const nextErrors = { ...this.apiErrors };
            delete nextErrors[field];
            delete nextErrors.general;
            this.apiErrors = nextErrors;
        },
        setApiErrors(err) {
            const responseErrors = err && err.response && err.response.data && err.response.data.errors;
            if (responseErrors) {
                this.apiErrors = responseErrors;
                return;
            }

            const message = err && err.response && err.response.data && (err.response.data.message || err.response.data.mensagem);
            this.apiErrors = {
                general: [message || 'Ops! Houve um erro ao salvar o vendedor.']
            };
        },
        validateForm () {
            return new Promise((resolve, reject) => {
                const resp = []
                if (!this.modalSeller.name) resp.push('Por favor adicione um nome')
                if (!this.modalSeller.email) resp.push('Por favor adicione um email')
                if (!this.modalSeller.phone) resp.push('Por favor adicione um numero de telefone')
                if (!this.modalSeller.login) resp.push('Por favor adicione um login')
                if (!this.modalSeller.password) delete this.modalSeller.password
                if (!this.modalSeller.profile) resp.push('Por favor selecione um perfil')
                if (resp.length > 0) reject(resp)
                else resolve()
            })
        },
        save() {
            this.apiErrors = {};
            this.validateForm().then(() => {
                this.present_loader("Salvando vendedor...")
                return this.svc.save(this.modalSeller).then(() => {
                    this.present_info('Dados salvos com sucesso!')
                    this.$emit('reload')
                }).catch((err) => {
                    this.setApiErrors(err)
                    this.dismiss_loader()
                })
            }).catch(errors => {
                errors.forEach(error => {
                    const notification = {
                        type: 'error',
                        message: error
                    }
                    this.$store.dispatch('notification/add', notification)
                })
            })

        }
    }
};
</script>

<style>
.add-selller-body {
  padding: 1vh 5vw;
}
.add-seller-title-container {
  display: flex;
  justify-content: space-between;
  font-size: 1.5em;
  color: var(--primary-color);
  margin-bottom: 3vh;
  align-items: center;
}
.add-seller-body {
  margin-top: 3vh;
  margin-left: 5vw;
}
.add-seller-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 4vh;
}
.add-selller-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 5vw;
  margin-bottom: 5vh;
}
.add-seller-button {
  width: 15%;
}
.add-seller-input {
  width: 45%;
}
.seller-form-errors {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
}
.seller-field-error {
  display: block;
  line-height: 1.35;
  margin-top: 4px;
  padding: 0;
}
@media only screen and (max-width: 750px) {
  .add-seller-row {
    flex-direction: column;
    gap: 5vh;
  }
  .add-seller-input {
    width: 100%;
  }
  .add-seller-button {
    width: 45%;
  }
}
</style>
